"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  olivemagazine: {
    domain: 'olivemagazine.com',
    theme: 'im-olive-theme',
    adobeFontsId: 'qlz3nrr'
  },
  radiotimes: {
    theme: 'im-rt-theme',
    domain: 'radiotimes.com',
    adobeFontsId: 'fer7rij',
    language: 'en-GB',
    dateTimeFormat: {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  },
  radiotimesmoney: {
    theme: 'im-rtmoney-theme',
    domain: 'radiotimesmoney.com',
    adobeFontsId: 'fer7rij'
  },
  sciencefocus: {
    theme: 'im-sciencefocus-theme',
    domain: 'sciencefocus.com',
    adobeFontsId: 'cxp3xqw',
    language: 'en-GB',
    dateTimeFormat: {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    }
  },
  slate: {
    domain: 'im-slate.com',
    theme: 'im-slate-theme',
    adobeFontsId: 'sts5pxq'
  },
  historyextra: {
    theme: 'im-historyextra-theme',
    domain: 'historyextra.com',
    adobeFontsId: 'jgm6vxd'
  },
  cyclingplus: {
    theme: 'im-cyclingplus-theme',
    domain: 'cyclingplus.com',
    adobeFontsId: 'ibb4qzb'
  },
  mountainbikeuk: {
    theme: 'im-mbuk-theme',
    domain: 'mbuk.com',
    adobeFontsId: 'ver5vvi'
  },
  gardenersworld: {
    theme: 'im-gw-theme',
    domain: 'gardenersworld.com',
    adobeFontsId: 'jrx3jsy',
    language: 'en-GB',
    dateTimeFormat: {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  },
  calmmoment: {
    theme: 'im-calmmoment-theme',
    domain: 'calmmoment.com',
    adobeFontsId: 'dgu2ytl'
  },
  policies: {
    theme: 'im-immediate-theme',
    domain: 'policies.immediate.co.uk',
    adobeFontsId: 'snd2ukk'
  },
  gardensillustrated: {
    theme: 'im-gardensillustrated-theme',
    domain: 'gardensillustrated.com',
    adobeFontsId: 'gxk7dqy'
  },
  homesandantiques: {
    theme: 'im-homesandantiques-theme',
    domain: 'homesandantiques.com',
    adobeFontsId: 'tmb5ihd'
  },
  historyrevealed: {
    theme: 'im-historyrevealed-theme',
    domain: 'historyrevealed.com',
    adobeFontsId: 'qql8glb'
  },
  bikeradar: {
    theme: 'im-bikeradar-theme',
    domain: 'bikeradar.com',
    adobeFontsId: 'evz1piy'
  },
  countryfile: {
    theme: 'im-countryfile-theme',
    domain: 'countryfile.com',
    adobeFontsId: 'pcz7ccj'
  },
  discoverwildlife: {
    theme: 'im-discoverwildlife-theme',
    domain: 'discoverwildlife.com',
    adobeFontsId: 'gff4jki'
  },
  'classical-music': {
    theme: 'im-classicalmusic-theme',
    domain: 'classical-music.com',
    adobeFontsId: 'vxp5evx'
  },
  skyatnightmagazine: {
    theme: 'im-skyatnight-theme',
    domain: 'skyatnightmagazine.com',
    adobeFontsId: 'kdh6jpn'
  },
  whodoyouthinkyouaremagazine: {
    theme: 'im-wdytya-theme',
    domain: 'whodoyouthinkyouaremagazine.com',
    adobeFontsId: 'nmv8rou'
  },
  britishcraftawards: {
    theme: 'im-slate-theme',
    domain: 'britishcraftawards.com',
    adobeFontsId: 'pwz8bqh'
  },
  madeformums: {
    theme: 'im-madeformums-theme',
    domain: 'madeformums.com',
    adobeFontsId: 'sqa2rfw'
  },
  bbcgoodfood: {
    domain: 'bbcgoodfood.com',
    theme: 'im-bbcgoodfood-theme',
    adobeFontsId: 'xij0cqx'
  },
  junior: {
    theme: 'im-junior-theme',
    domain: 'juniormagazine.co.uk',
    adobeFontsId: 'qdj6zdx'
  },
  gathered: {
    theme: 'im-gathered-theme',
    domain: 'gathered.how',
    adobeFontsId: 'rwy3wtk'
  },
  twotwentytriathlon: {
    theme: 'im-twotwentytriathlon-theme',
    domain: '220triathlon.com',
    adobeFontsId: 'qxx2luy'
  },
  ekbbmagazine: {
    theme: 'im-ekbbmagazine-theme',
    domain: 'ekbbmagazine.co.uk',
    adobeFontsId: 'xow0wcl'
  },
  kbbdaily: {
    theme: 'im-kbbdaily-theme',
    domain: 'kbbdaily.com',
    adobeFontsId: 'rjg3hox'
  },
  yourhomestyle: {
    theme: 'im-yourhomestyle-theme',
    domain: 'yourhomestyle.uk',
    adobeFontsId: 'lvh7pmn'
  },
  therecommended: {
    theme: 'im-therecommended-theme',
    domain: 'therecommended.com',
    adobeFontsId: 'gug4ypu'
  },
  viva: {
    theme: 'bmp-viva-theme',
    domain: 'viva.pl',
    adobeFontsId: 'cvt8iwj',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  },
  party: {
    theme: 'bmp-party-theme',
    domain: 'party.pl',
    adobeFontsId: 'ogg0pql',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  },
  imlogging: {
    domain: 'imlogging.co.uk',
    theme: 'im-slate-theme',
    adobeFontsId: 'sts5pxq'
  },
  jeuvareno: {
    domain: 'jeuvareno.cz',
    theme: 'im-bbcgoodfood-theme',
    adobeFontsId: 'wkp2jvw',
    language: 'cs-CZ'
  },
  varimerychle: {
    domain: 'varimerychle.cz',
    theme: 'im-bbcgoodfood-theme',
    adobeFontsId: 'wkp2jvw',
    language: 'cs-CZ'
  },
  platosricos: {
    domain: 'platosricos.es',
    theme: 'im-bbcgoodfood-theme',
    adobeFontsId: 'wkp2jvw',
    language: 'es-ES',
    dateTimeFormat: {
      dateStyle: 'full'
    }
  },
  wizaz: {
    theme: 'bmp-wizaz-theme',
    domain: 'wizaz.pl',
    adobeFontsId: 'hbs6gcb',
    language: 'pl-PL',
    dateTimeFormat: {
      dateStyle: 'full',
      timeStyle: 'short'
    }
  }
};
exports.default = _default;